import axios from 'axios';
import type { PartnerShopListResponse } from '@/types/partnerShop';
import type { HomeCategoryTabKey } from '@/pages/home/constants';

export interface MainReviewImage {
  id: number;
  partnerShopId: number;
  shopName: string;
  shopSlug: string;
  shopCategory: string;
  src: string;
  thumbnailSrc: string;
  category: string;
  caption: string;
  confidence: number;
}

export interface MainReviewCategoryData {
  shopCategory: string;
  reviewQuotes: string[];
  reviewImages: MainReviewImage[];
}

export type MainReviewsData = Partial<Record<HomeCategoryTabKey, MainReviewCategoryData>>;

export async function getMainReviews() {
  const response = await axios.get('/api/partner-shops/main/reviews');
  const result = response.data;

  if (!result || result.status !== 200) {
    throw new Error(result?.message || '메인페이지 후기 정보를 불러오지 못했습니다.');
  }

  return result.data as MainReviewsData;
}

export type MainPartnerShopCategoryMap = Partial<
  Record<HomeCategoryTabKey, PartnerShopListResponse>
>;

export async function getMainPartnerShopsByCategory() {
  const response = await axios.get('/api/partner-shops/list/all-category');
  const result = response.data;

  if (!result || result.status !== 200) {
    throw new Error(result?.message || '메인페이지 추천 인증업체를 불러오지 못했습니다.');
  }

  return result.data as MainPartnerShopCategoryMap;
}
